import React, { Fragment, useMemo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { PDFDocument } from 'pdf-lib';

import PdfToTextSelectPage from "./PdfToTextSelectPage.jsx";
// import Loader from "../Loader/Loader.jsx";
import { useStore } from "../../hook-store/store.js";
import { marks } from "../../utils/marks.jsx";

// import { ollamaMcpPdfToText } from "../../utils/ollama/pdf-file.js";
// import { marks } from "../../../utils/marks.jsx";
import "./PdfToText.css";
import "./PdfToTextResult.css"


export default function PdfToTextResult(props) {
    const { 
      // inputPdfFile,
      // setPdfTextData,
      pdfTextData,
      outputTextFile,
      setOutputTextFile,
      outputText,
      setOutputText,
    } = props;

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    // const { 
    // } = store.mlSpeechStore;

    const [showSelectPage, setShowSelectePage] = useState(false);
    const [selectedPageIdxs, setSelectedPageIdxs] = useState([]);

    //// initialize selected indexes when pdfData changed.
    useEffect(() => {
      setShowSelectePage(false);
      setSelectedPageIdxs([]);
    },[pdfTextData]);


    const createCombineTextHandler = async (pdfTextData, pageIdxs) => {
      try {
        let combinedText = '';
        const pageSeparateText = '\n\n'
  
        if (!pageIdxs) {
          for (const data of pdfTextData) {
            combinedText = combinedText + pageSeparateText + data.page_content;
          }
        }
  
        if (pageIdxs) {
          for (const idx of pageIdxs) {
            const pageContent = pdfTextData[idx].page_content;
  
            combinedText = combinedText + pageSeparateText + pageContent;
          }
        }
  
        // console.log(combinedText);
       
        // var jsonString = JSON.stringify(text);
        var blob = new Blob([combinedText], { type: 'text/plain' });
        var file = new File([blob], `text-from-pdf-${Date.now()}.txt`, {type: "text/plain"});
        
        setOutputTextFile(file);
  
        await getOutputTextHandler(URL.createObjectURL(file));
        console.log(file);
        return file;

      } catch(err) {
        console.log(err);
        throw err;
      }
    };

    const getOutputTextHandler = async (url) => {
      try {
        const result = await fetch(url);
        const resData = await result.text();
        // console.log('resData', resData, result)
        if (resData) {
          setOutputText(resData);
        }

      } catch(err) {
        console.log(err);
        throw err;
      }
    };
    
    // const selecteTextPageHandler = (idx) => {

    //   const prePages = selectedPageIdxs;
    //   console.log(prePages)

    //   const isInList = prePages.find(ele => {
    //     return ele === idx;
    //   })

    //   if (!isInList) {
    //     const addedList = prePages.concat([idx]);
    //     console.log(addedList);
    //     setSelectedPageIdxs(addedList);
    //   }
    // };



    let pdfToTextResultBody;

    if (pdfTextData && pdfTextData.length > 0) {
      pdfToTextResultBody = (
        <div>
          <div className="pdfToTextRow">
            <div>
              <strong>
                {t('pdfToText10', 'Text data from pdf file')}
              </strong>
            </div>
            <ul className="pdfToTextResultPreview"
              // style={{border: "2px solid green", height: "400px", overflow: "auto"}}
            >
              {pdfTextData.map((data, index) => {
                return (
                  <li key={index}
                    className="pdfToTextResultPreviewPage"
                    // style={{whiteSpace: "pre-wrap", border:"1px solid red", marginBottom: "2rem"}}
                  >
                    <div>
                      {data.page_content}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>

          {pdfTextData && pdfTextData.length > 0 && (
            <div>
              <div>
                <strong>
                  {t('pdfToText11', 'Create text file')}
                </strong>
              </div>
              <div className="pdfToTextResultButtons">
                <button className="btnBase"
                  onClick={() => {
                    createCombineTextHandler(pdfTextData, null);
                  }}
                >
                  {t('pdfToText11', 'Create text file')}
                </button>
                {pdfTextData && pdfTextData.length > 1 && (
                  <span>
                    <span>{' '}{t('pdfToText12', 'or')}{' '}</span>
                    <button className="btnBase"
                      onClick={() => {
                        setShowSelectePage(!showSelectPage);
                      }}
                    >
                      {t('pdfToText13', 'Select pages')}
                      {' '}{marks.triangleDown}
                    </button>
                  </span>
                )}
              </div>
            </div>
          )}
          <div>
            <PdfToTextSelectPage 
              pdfTextData={pdfTextData}
              showSelectPage={showSelectPage}
              setShowSelectePage={setShowSelectePage}
              selectedPageIdxs={selectedPageIdxs}
              setSelectedPageIdxs={setSelectedPageIdxs}
              createCombineTextHandler={createCombineTextHandler}
            />
          </div>

          {outputText && (
            <div className="pdfToTextRow">
              <div>
                <strong>
                  {t('pdfToText14', 'Text file contents')} 
                  {' '}{marks.fileTextOMark}
                </strong>
              </div>
              <div className="pdfToTextResultOutputTextPreview"
              //  style={{overflow: "auto", height: "400px"}}
              >
                {outputText}
              </div>
            </div>
          )}

        </div>
      );
    }

    return (
        <Fragment>
          <div>{pdfToTextResultBody}</div>
        </Fragment>
    );
  };
